import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useField } from "formik";
import { FormControl, FormHelperText, FormLabel } from "@material-ui/core";
export function FormikFormControlFieldset(props) {
    const { name, helperText, label, children, ...rest } = props;
    const [, meta] = useField({ name });
    const error = meta.error;
    const showError = Boolean(error) && meta.touched;
    const helperOrErrorText = showError ? error : helperText;
    return (_jsxs(FormControl, { variant: "standard", component: "fieldset", error: showError, ...rest, children: [label && _jsx(FormLabel, { component: "legend", children: label }), children, helperOrErrorText && (_jsx(FormHelperText, { children: helperOrErrorText }))] }));
}
//# sourceMappingURL=FormikFormControlFieldset.js.map